import { ColumnImporterSettings } from '@components/trace/column/column.importer.settings';
import { Separator } from '@components/ui/separator';

import type { AtomModel } from '@models/atom.model';

import type { TableImporterTextColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TableImporterTextColumnData>;
};

export const TextSettingsModal = ({ atom }: Props) => (
  <>
    <ColumnImporterSettings
      columnName={atom.data.title}
      from={atom.data.importerOptions.from}
      onFromChange={v => (atom.data.importerOptions.from = v)}
    />
    <Separator />
  </>
);
